<template>
  <div class="ihu-fm-modal-wrapper">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">
          <slot name="header"></slot>
        </div>
        <div class="modal-header-close" @click="closeModal"></div>
      </div>
      <div class="modal-mid">
        <div v-if="hasSlot('modal-nav')" class="modal-nav">
          <slot name="modal-nav"></slot>
        </div>
        <div v-if="isLoading" class="loader-wrapper">
          <le-loader class="spinner" :size="80"></le-loader>
        </div>
        <slot></slot>
      </div>
      <div v-if="hasSlot('modal-footer')" class="modal-footer">
        <slot name="modal-footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import leLoader from '@vueComponents/le-loader/le-loader.vue';

  export default {
    name: 'ihu-fullscreen-modal',
    components: {
      leLoader,
    },

    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      hasSlot(slotName) {
        return !!this.$slots[slotName];
      },
      closeModal() {
        this.$emit('closeClicked');
      },
    },
  };
</script>

<style scoped lang="scss">
  .loader-wrapper {
    display:flex;
    height: 100%;
    width: 100%;
    position:absolute;
    top:0;
    left:0;
    background-color: rgba(255,255,255,.1);
    align-items: center;
    justify-content: center;
  }
  .ihu-fm-modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    padding: 0;
    height: 100vh;
    width: 100vw;
    z-index: 2000;
  }
  .modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;

    @include themify {
      background-color: getColor('setupContentBackground', 'ihu');
    }

    & > .modal-header {
      height: 52px;
      line-height: 52px;
      position: relative;
      flex-grow: 0;

      @include themify {
        background-color: getColor('ihuFullScreenModalHeader', 'ihu');
      }

      .modal-header-title {
        float: left;
        position: relative;
        left: 24px;
        font-size: 14px;
        font-style: normal;
        font-family: Roboto;

        @include themify {
          color: getColor('ihuFullScreenModalHeaderTitle', 'ihu');
        }
      }

      .modal-header-close {
        float: right;
        right: 27.1px;
        position: relative;
        height: 52px;
        width: 21px;
        cursor: pointer;
        @include themify('dark') {
          background: url('~@/components/common/assets/navigation/close_cross_dark.svg') no-repeat center;
        }
        @include themify('light') {
          background: url('~@/components/common/assets/navigation/close_cross_light.png') no-repeat center;
        }
      }
    }

    & > .modal-mid {
      display: flex;
      position: relative;
      flex-direction: row;
      flex-grow: 1;
      overflow: auto;

      .modal-nav {
        width: 244px;
        overflow-y: hidden;
        flex-shrink: 0;
      }
    }

    & > .modal-footer {
      min-height: 84px;
      width: 100vw;
      flex-grow: 0;
      z-index: 1;

      @include themify {
          background-color: getColor('ihuFullScreenModalFooter', 'ihu');
      }
    }
  }
</style>

